/* Aden Salt — customer account form (/get-started/). Theme addition, not from the original funnel.
   1. "Same as owner" under Contact Person: copies Owner Name into the box and keeps the two in step.
   2. Phone: drops a leading 1. The field's mask keeps the first ten digits, so a number typed or
      auto-filled as "+1 845 555 0100" would otherwise be saved as "(184) 555-5010". No US area
      code starts with 1, so nothing real is lost.
   3. Hand-off from a pickup quote: fills the form from what the visitor typed on the home page
      (sessionStorage, written by 20-hero.js handoff()), then deletes it. See the last block.
   Listeners sit on the document because Gravity Forms replaces the form's markup after a failed
   submit. Does nothing on pages without the form. */
(function(){
  function phoneInput(el){
    return el && el.matches && el.matches('.acct .ginput_container_phone input') ? el : null;
  }
  /* Capture phase: these must run before the mask's own handlers see the value or the key. */
  document.addEventListener('input', function(e){
    var el = phoneInput(e.target);
    if(!el) return;
    var d = el.value.replace(/\D/g, '');
    if(d.charAt(0) === '1') el.value = d.slice(1);
  }, true);
  document.addEventListener('keydown', function(e){
    var el = phoneInput(e.target);
    if(!el || e.key !== '1' || e.ctrlKey || e.metaKey || e.altKey) return;
    if(el.value.replace(/\D/g, '') === ''){ e.preventDefault(); e.stopPropagation(); }
  }, true);
})();
(function(){
  function fieldInput(box, cls){
    var form = box.closest('form');
    return form ? form.querySelector('.' + cls + ' input[type="text"]') : null;
  }
  function sync(box){
    var owner = fieldInput(box, 'acct-owner'), contact = fieldInput(box, 'acct-contact');
    if(!owner || !contact) return;
    contact.readOnly = box.checked;
    contact.classList.toggle('is-same', box.checked);
    if(box.checked) contact.value = owner.value;
  }
  document.addEventListener('change', function(e){
    if(e.target && e.target.classList && e.target.classList.contains('acct-same__box')) sync(e.target);
  });
  document.addEventListener('input', function(e){
    var field = e.target && e.target.closest ? e.target.closest('.acct-owner') : null;
    if(!field) return;
    var box = field.closest('form').querySelector('.acct-same__box');
    if(box && box.checked) sync(box);
  });
})();

/* Hand-off from a pickup quote. The details are read once and removed at once, are ignored after 30
   minutes (counted from when the visitor left the home page), never touch the address bar and are sent
   nowhere: they only become the starting values of
   fields the visitor can see and change (plus the four hidden "quote_" fields saying what was asked
   for). A field that already holds something is left alone. */
(function(){
  var KEY = 'adensaltAccountPrefill', MAX_AGE = 30 * 60 * 1000;
  function run(){
    var map, raw = null, d;
    /* read once and delete first, whatever happens next, even if the form is not on the page */
    try{ raw = sessionStorage.getItem(KEY); sessionStorage.removeItem(KEY); }catch(err){ return; }
    var mapEl = document.querySelector('.acct-field-map');
    if(!raw || !mapEl) return;
    try{ map = JSON.parse(mapEl.textContent || '{}'); }catch(err){ return; }
    try{ d = JSON.parse(raw); }catch(err){ return; }
    if(!d || typeof d !== 'object' || typeof d.at !== 'number' || Date.now() - d.at > MAX_AGE || d.at > Date.now() + 60000) return;
    function text(v){ return typeof v === 'string' || typeof v === 'number' ? String(v).replace(/\s+/g, ' ').trim().slice(0, 200) : ''; }
    function set(name, value){
      var el = map[name] ? document.getElementById(map[name]) : null;
      value = text(value);
      if(!el || !value || el.value) return false;
      if(el.tagName === 'SELECT' && !Array.prototype.some.call(el.options, function(o){ return o.value === value; })) return false;
      el.value = value;
      el.dispatchEvent(new Event('input', {bubbles:true}));
      el.dispatchEvent(new Event('change', {bubbles:true}));
      return true;
    }
    var ph = text(d.phone).replace(/\D/g, '');
    if(ph.length === 11 && ph.charAt(0) === '1') ph = ph.slice(1);
    var filled = 0;
    [ ['contact_name', d.name],
      ['phone', ph.length === 10 ? '(' + ph.slice(0, 3) + ') ' + ph.slice(3, 6) + '-' + ph.slice(6) : ''],
      ['email', d.email],
      ['addr_zip', /^\d{5}$/.test(text(d.zip)) ? d.zip : ''],
      ['addr_city', d.city],
      ['addr_county', d.county]
    ].forEach(function(p){ if(set(p[0], p[1])) filled++; });
    var st = text(d.state).toUpperCase();
    if(st && (set('addr_state', st) || set('addr_state', 'other'))) filled++;
    ['product', 'tonnage', 'fulfillment', 'nearest_yard'].forEach(function(k){ set('quote_' + k, d[k]); });
    var notice = mapEl.getAttribute('data-notice');
    var wrap = document.querySelector('.acct__form');
    if(filled && notice && wrap){
      var p = document.createElement('p');
      p.className = 'acct__prefill';
      p.setAttribute('role', 'status');
      wrap.insertBefore(p, wrap.firstChild);
      /* filled a moment after the empty status region is in the page, so screen readers announce it */
      setTimeout(function(){ p.textContent = notice; }, 150);
    }
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
